import React, { Component } from 'react';
import { Button } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import { Link } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';

// Assets
import dc_ico from "../../../Assets/images/dc_ico.png";
import logout from "../../../Assets/images/logout.png";
import service from "../../../Assets/images/service.png";
import reports from "../../../Assets/images/reports.png";
import setting from "../../../Assets/images/setting.png";
import userico from "../../../Assets/images/userico.png";
import userimg from "../../../Assets/images/userimg.jpg";
import doocy_call from "../../../Assets/images/dctext.png";
import dashboard from "../../../Assets/images/dashboard.png";
import franchise from "../../../Assets/images/franchise.png";
import case_mgmt from "../../../Assets/images/case_mgmt.png";
import commercial from "../../../Assets/images/commercial.png";
import accounting from "../../../Assets/images/accounting.png";
import residential from "../../../Assets/images/residential.png";
class Sidebar extends Component {

  constructor(props) {
    super(props);
    this.state = {
      collapsed: true,
    };

    this.state = { logginStatus: true, hasOpen: false };

    let user = localStorage.getItem('authUser');
    if (user) {
      this.events = [
        "load",
        "mousemove",
        "mousedown",
        "click",
        "scroll",
        "keypress"
      ];

      this.logout = this.logout.bind(this);
      this.resetTimeout = this.resetTimeout.bind(this);

      for (var i in this.events) {
        window.addEventListener(this.events[i], this.resetTimeout);
      }

      this.setTimeout();
    } else {
      clearTimeout(this.logoutTimeout);
    }
  }
    
  clearTimeout() {
    if (this.logoutTimeout) clearTimeout(this.logoutTimeout);
  }

  setTimeout() {
    this.logoutTimeout = setTimeout(this.logout, 900000);
  }

  resetTimeout() {
    this.clearTimeout();
    this.setTimeout();
  }

  logout() {
    // Send a logout request to the API
    localStorage.clear(); 
    sessionStorage.clear();
    this.setState({ logginStatus: false });
    this.destroy(); // Cleanup
    window.location.assign('/')
  }

  destroy() {
    this.clearTimeout();
    for (var i in this.events) {
      window.removeEventListener(this.events[i], this.resetTimeout);
    }
  }
  
  toggleCollapsed = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    });
  };

  toggleSubMenu = () => {
    this.setState({hasOpen: !this.state.hasOpen});
  };

  render() {
    const user = JSON.parse(localStorage.getItem("authUser"))
      ? JSON.parse(localStorage.getItem("authUser"))
      : "";
    const pathname = window.location.pathname;
    
    return (
      <div className="side-nav" >
        <div className="ant-menu ant-menu-inline-collapsed">
          <Button type="primary" className="plain-btn" onClick={this.toggleCollapsed}>
            <img src={dc_ico} alt="" /> <img src={doocy_call} alt="" />
          </Button>
          <ScrollArea
            speed={0.8}
            className="vertical-scroll"
            contentClassName="content"
            horizontal={false}
          >
            <ul className="">

              <li className={`ant-menu-item ${pathname.includes('/dashboard') ? 'active' : ''}`}>
                <Link to={'/dashboard'}>
                  <span className="mitem">
                    <img src={dashboard} alt="" />
                    <span>Dashboard</span>
                  </span>
                </Link>
              </li>
              <li className={`ant-menu-item ${pathname.includes('/franchise') ? 'active' : ''}`}>
                <Link to={'/franchise'}>
                  <span className="mitem">
                    <img src={franchise} alt="" />
                    <span>Franchises</span>
                  </span>
                </Link>
              </li>
              <li className={`ant-menu-item ${pathname.includes('/residential') ? 'active' : ''}`}>
                <Link to={'/residential'}>
                  <span className="mitem">
                    <img src={residential} alt="" />
                    <span>Residential</span>
                  </span>
                </Link>
              </li>
              <li className={`ant-menu-item ${pathname.includes('/commercial') ? 'active' : ''}`}>
                <Link to={'/commercial'}>
                  <span className="mitem">
                    <img src={commercial} alt="" />
                    <span>Commercial</span>
                  </span>
                </Link>
              </li>
              <li className={`ant-menu-item ${pathname.includes('/user-list') ? 'active' : ''}`}>
                <Link to={'/user-list'}>
                  <span className="mitem">
                    <img src={userico} alt="" />
                    <span>User Management</span>
                  </span>
                </Link>
              </li>
              <li className={ `ant-menu-submenu ant-menu-submenu-inline ant-menu-item ${pathname.includes('/field_tech/week_setup') || pathname.includes('/field_tech/eod_report') || pathname.includes('/field_tech/scheduling_errors') ? 'active' : '' } ${(this.state.hasOpen ? ' has-open' : '')}`} onClick={this.toggleSubMenu}> <a><span className="mitem" > <img src={service} alt="" /> <span>Field Service</span> </span><DownOutlined className="ant-menu-submenu-arrow" /></a> 
                <ul className="ant-menu-sub ant-menu-inline">
                  <li className={ `ant-menu-item ${pathname.includes('/field_tech/week_setup') || pathname.includes('/field_tech/eod_report') ? 'active' : ''}`}>
                    <Link to={'/field_tech/week_setup'}>
                      <span className="mitem">
                        <span>OptimoRoute Scheduling</span>
                      </span>
                    </Link>
                  </li>
                  <li className={ `ant-menu-item ${pathname.includes('/field_tech/scheduling_errors') ? 'active' : ''}`}>
                    <Link to={'/field_tech/scheduling_errors'}>
                      <span className="mitem">
                        <span>Scheduling Errors</span>
                      </span>
                    </Link>
                  </li>
                  <li className={ `ant-menu-item ${pathname.includes('/field_tech/bulk-reassign') || pathname.includes('/field_tech/bulk-reassign') ? 'active' :''}`}>
                    <Link to={'/field_tech/bulk-reassign'}>
                      <span className="mitem">
                        <span>Bulk Reassign Technician</span>
                      </span>
                    </Link>
                  </li>
                  <li className={ `ant-menu-item ${pathname.includes('/field_tech/view-by-work-order') || pathname.includes('/field_tech/view-by-work-order') ? 'active' : ''}`}> <Link to={'/field_tech/view-by-work-order'}><span className="mitem"><span>View By Work Order</span> </span></Link> </li>
                </ul>
              </li>              
              <hr />
              <li className={`ant-menu-item ${pathname.includes('/account') ? 'active' : ''}`}>
                <Link to={'/account'}>
                  <span className="mitem">
                    <img src={accounting} alt="" />
                    <span>Accounting</span>
                  </span>
                </Link>
              </li>
              <li className={`ant-menu-item ${pathname.includes('/case-management') ? 'active' : ''}`}>
                <Link to={'/case-management'}>
                  <span className="mitem">
                    <img src={case_mgmt} alt="" />
                    <span>Case Management</span>
                  </span>
                </Link>
              </li>
              <li className={`ant-menu-item ${pathname.includes('/reports') ? 'active' : ''}`}> 
                <Link to={'/reports'}>
                  <span className="mitem">
                    <img src={reports} alt="" />
                    <span>Reports</span>
                  </span>
                </Link>
              </li>
              <li className={`ant-menu-item ${pathname.includes('/settings') ? 'active' : ''}`}>
                <Link to={'/settings'}>
                  <span className="mitem">
                    <img src={setting} alt="" />
                    <span>Settings</span>
                  </span>
                </Link>
              </li>
            </ul>
          </ScrollArea >
          <ul className="btm-menu">
            {/* <li className="ant-menu-item opitem"> <span className="mitem"> <figure className="user-status"><img className="userimg" src={userimg} alt="" /><small className="astatus"></small></figure> <span>Jacob D Aniello</span> </span></li>
            <li className="ant-menu-item opitem"> <span className="mitem"><img src={logout} alt="" /> <span>Log Out</span> </span></li> */}

            <li className="ant-menu-item opitem"> <span className="mitem">
              <figure className="user-status">{user?.user?.photo ?
                <img className="userimg" src={user.user.photo} alt="" />
                : <img className="userimg" src={userimg} alt="" />}<small className="astatus"></small>
              </figure>
              <span className="ellipse">{user && user.user.first_name} {user && user.user.last_name}</span> </span></li>
            <li className="ant-menu-item opitem"> <Link to="/" className="mr-2" replace onClick={() => { localStorage.clear(); sessionStorage.clear(); }}><span className="mitem"><img src={logout} alt="" /> <span>Log Out</span> </span></Link> </li>
            {/* <li key="11"> <img src={dashboard} alt="" /> Franchises </li> */}
          </ul>
        </div>
      </div>
    );
  }
}

export default Sidebar;